import { render, staticRenderFns } from "./coomdsPrices.vue?vue&type=template&id=05a06bbb&scoped=true"
import script from "./coomdsPrices.vue?vue&type=script&lang=ts"
export * from "./coomdsPrices.vue?vue&type=script&lang=ts"
import style0 from "./coomdsPrices.vue?vue&type=style&index=0&id=05a06bbb&prod&lang=less&scoped=true"
import style1 from "./coomdsPrices.vue?vue&type=style&index=1&id=05a06bbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a06bbb",
  null
  
)

export default component.exports